class HomeService {
    constructor($q, $http, ngAuthSettings) {
        this.ngAuthSettings = ngAuthSettings;
        this.$q = $q;
        this.$http = $http;
    }

    getProductsBySearchText(pageNumber, searchText, third) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'GET',
                url: this.ngAuthSettings.apiServiceBaseUri + '/items/items/search-items?pageSize=' + 5 + '&pageNumber=' + pageNumber + '&searchText=' + searchText + '&terceroId=' + third,
                cache: true
            }).then((response) => {
                resolve(response.data);
            }, (reason) => {
                reject(reason);
            });
        });
    }

    getCMSBanners(pageName,adaptative = false, company = '') {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'GET',
                url: this.ngAuthSettings.apiServiceBaseUri +
                this.ngAuthSettings.config.paths.getCMS + "?pageName=" + pageName + "?company" + company,
                cache: false
            }).then(response => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }


}

HomeService.$inject = ['$q', '$http', 'ngAuthSettings'];

export default HomeService;



/** WEBPACK FOOTER **
 ** C:/Bitnami/wampstack-7.1.31-0/apache2/htdocs/toning/B2C/www/components/home/home.service.js
 **/